var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_7832",
    "data-name": "\\u7EC4 7832",
    transform: "translate(-797 -586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_4825",
    "data-name": "\\u8DEF\\u5F84 4825",
    d: "M76,254H68a2,2,0,0,1-2-2v-6a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v6A2,2,0,0,1,76,254Zm-3-11H71a2,2,0,0,1-2-2v-1a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v1A2,2,0,0,1,73,243Z",
    transform: "translate(735 349)",
    fill: "rgba(153,153,153,0.2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_4826",
    "data-name": "\\u8DEF\\u5F84 4826",
    d: "M74,255H64a2,2,0,0,1-2-2v-8a2,2,0,0,1,2-2h1.277A1.98,1.98,0,0,1,65,242v-3a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v3a1.981,1.981,0,0,1-.278,1H74a2,2,0,0,1,2,2v8A2,2,0,0,1,74,255Zm-2-15a2,2,0,0,0-2-2H68a2,2,0,0,0-2,2v1a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2Zm3,6a2,2,0,0,0-2-2H65a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2Zm-6,6a1,1,0,0,1-1-1v-4a1,1,0,0,1,2,0v4A1,1,0,0,1,69,252Z",
    transform: "translate(735 349)",
    fill: "#999",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/密码.bce46ae135c381c6a32728bcad1306d9.svg";
export { ForwardRef as ReactComponent };